<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->

<div class="page-content" lmsSticky>
	<div class="wrapper">

		<lms-header *ngIf="showHeader"></lms-header>
		<lms-page></lms-page>
	</div>
</div>
<div [ngClass]="{'showLoading':loading}" *ngIf="loading">
	<div class="loader sk-child">
		<div class="spin1 "></div>
		<div class="spin2"></div>
		<div class="spin3"></div>
		<div class="spin4"></div>
		<div class="spin5"></div>
		<div class="spin6"></div>
		<div class="spin7"></div>
		<div class="spin8"></div>
		<div class="spin9"></div>
		<div class="spin10"></div>
		<div class="spin11"></div>
		<div class="spin12"></div>
	</div>
</div>